import { createSlice } from '@reduxjs/toolkit';

const attachmentSlice = createSlice({
  name: 'attach',
  initialState: {
    uploadFileData: {},
    uploadFileDataIsLoading: false,
    uploadFileDataErrorMsg: null,
  },
  reducers: {
    uploadFileReq: (state, action) => { },
    uploadFileSuccess: (state, action) => ({
      ...state,
      uploadFileData: action.payload,
      uploadFileDataIsLoading: false,
      uploadFileDataErrorMsg: null,
    }),
    uploadFileFailure: (state, action) => ({
      ...state,
      uploadFileDataIsLoading: false,
      uploadFileDataErrorMsg: action.payload,
    }),
    uploadFileLoading: (state) => ({
      ...state,
      uploadFileDataIsLoading: true,
      uploadFileDataErrorMsg: null,
    }),
    uploadFileClear: (state) => ({
      ...state,
      uploadFileData: {},
      uploadFileDataIsLoading: false,
      uploadFileDataErrorMsg: null,
    }),
  },
});

export const {
  uploadFileClear,
  uploadFileFailure,
  uploadFileLoading,
  uploadFileReq,
  uploadFileSuccess,
} = attachmentSlice.actions;

export default attachmentSlice.reducer;
